'use client';
import { useEffect } from 'react';

import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import SectionHeader from '@/components/ui/SectionHeader';

export default function CookiesPage() {
  useEffect(() => {
    const reveals = document.querySelectorAll('.reveal');
    if (!reveals?.length) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('active')),
      { threshold: 0.1 }
    );
    reveals?.forEach((el) => observer?.observe(el));
    return () => observer?.disconnect();
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background text-foreground pt-24">
        <section className="py-24 px-6 border-b border-border">
          <div className="max-w-[1600px] mx-auto">
            <SectionHeader
              eyebrow="Legal"
              title="Cookie Policy"
              description="Last updated: February 18, 2026"
              align="center"
              className="mb-16"
            />
          </div>
        </section>

        <section className="py-24 px-6">
          <div className="max-w-[900px] mx-auto">
            <div className="space-y-12">
              <div>
                <h2 className="text-2xl font-bold mb-4">1. What Are Cookies</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed">
                  Cookies are small text files that are placed on your computer or mobile device when you visit a website. They are widely used to make websites work more efficiently and provide information to website owners.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">2. How We Use Cookies</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed mb-4">
                  Best Odds Corp uses cookies for the following purposes:
                </p>
                <ul className="list-disc list-inside text-body-sm text-muted-foreground space-y-2 ml-4">
                  <li>Essential cookies: Required for the website to function properly</li>
                  <li>Analytics cookies: Help us understand how visitors interact with our website</li>
                  <li>Functionality cookies: Remember your preferences and settings</li>
                  <li>Marketing cookies: Track your browsing habits to show relevant advertisements</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">3. Types of Cookies We Use</h2>
                <div className="space-y-4">
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Essential Cookies</h3>
                    <p className="text-body-sm text-muted-foreground leading-relaxed">
                      These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you, such as setting your privacy preferences or filling in forms.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Analytics Cookies</h3>
                    <p className="text-body-sm text-muted-foreground leading-relaxed">
                      These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us understand which pages are most popular and how visitors move around the site.
                    </p>
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold mb-2">Functionality Cookies</h3>
                    <p className="text-body-sm text-muted-foreground leading-relaxed">
                      These cookies enable the website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages.
                    </p>
                  </div>
                </div>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">4. Third-Party Cookies</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed">
                  In addition to our own cookies, we may also use various third-party cookies to report usage statistics of the website and deliver advertisements on and through the website.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">5. Managing Cookies</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed mb-4">
                  You can control and manage cookies in various ways:
                </p>
                <ul className="list-disc list-inside text-body-sm text-muted-foreground space-y-2 ml-4">
                  <li>Browser settings: Most browsers allow you to refuse or accept cookies</li>
                  <li>Cookie preference tools: Use our cookie consent banner to manage your preferences</li>
                  <li>Third-party opt-out: Visit third-party websites to opt out of their cookies</li>
                </ul>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">6. Disabling Cookies</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed">
                  Please note that if you disable cookies, some features of our website may not function properly. You may not be able to take full advantage of all website features.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">7. Updates to This Policy</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed">
                  We may update this Cookie Policy from time to time to reflect changes in technology, legislation, our operations, or for other operational, legal, or regulatory reasons.
                </p>
              </div>

              <div>
                <h2 className="text-2xl font-bold mb-4">8. Contact Us</h2>
                <p className="text-body-sm text-muted-foreground leading-relaxed">
                  If you have any questions about our use of cookies, please contact us at hello@bestoddscorp.com or (702) 546-6337.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}